/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from "react";
import { Box, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useStyles } from "./styles";

export const ThreeDotOption = ({
  icon,
  text,
}: {
  icon: React.ReactNode;
  text: string;
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.threeDotBox}>
      <ListItemIcon className={classes.menuIconStyle}>{icon}</ListItemIcon>
      <ListItemText>{text}</ListItemText>
    </Box>
  );
};
